import { getParent } from 'mobx-state-tree';

import { updateUserAnalytics } from '../../../API/userAPI';

const Actions = self => ({
  setInfo: (analytics = {}) => {
    const {
      firstProspectingScoutSearchDate,
      firstProspectingFullShowDate,
      registerDate,
      lastTermsAndConditionsApprovalDate,
      firstShowDate,
      firstSearchDate,
    } = analytics;

    self.firstProspectingScoutSearchDate = firstProspectingScoutSearchDate ? new Date(firstProspectingScoutSearchDate) : null;
    self.firstProspectingFullShowDate = firstProspectingFullShowDate ? new Date(firstProspectingFullShowDate) : null;
    self.registerDate = registerDate ? new Date(registerDate) : null;
    self.lastTermsAndConditionsApprovalDate = lastTermsAndConditionsApprovalDate
      ? new Date(lastTermsAndConditionsApprovalDate)
      : self.registerDate;
    self.firstShowDate = firstShowDate ? new Date(firstShowDate) : null;
    self.firstSearchDate = firstSearchDate ? new Date(firstSearchDate) : null;
  },

  updateTermsAndConditionsApprovalDate: () => {
    const lastTermsAndConditionsApprovalDate = new Date();

    self.lastTermsAndConditionsApprovalDate = lastTermsAndConditionsApprovalDate;
    updateUserAnalytics(getParent(self).id, {
      lastTermsAndConditionsApprovalDate: lastTermsAndConditionsApprovalDate.toISOString().slice(0, 19).replace('T', ' '),
    });
  },
});

export default Actions;
